import { createFileRoute, notFound } from '@tanstack/react-router';
import { VideoDetailRoute } from '@/components/custom/video-detail-route';
import { websiteConfig } from '@/config/website';
import { authRouteMiddleware } from '@/middlewares/auth-middleware';
import { seo } from '@/lib/seo';

export const Route = createFileRoute('/video/$id')({
  server: {
    middleware: [authRouteMiddleware],
  },
  loader: async ({ params, context }) => {
    const { getVideoGeneration } = await import('@/api/video-generate');
    const item = await getVideoGeneration({ data: { id: params.id } });
    if (!item) throw notFound();
    context.queryClient.setQueryData(
      ['videoGenerationDetail', params.id],
      item
    );
    return item;
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const siteName = websiteConfig.metadata?.name ?? '';
    const title = siteName ? `Video | ${siteName}` : 'Video';
    return seo(`/video/${loaderData.id}`, {
      title,
      description: loaderData.prompt.slice(0, 160),
    });
  },
  component: VideoDetailRoute,
});
